module.exports = __webpack_public_path__ + "img/copy-05.6da71225.svg";